export const FORM_KEYS = Object.freeze({
  ABBREV: "ABBREV",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  BACKGROUND_COLOR: "BACKGROUND_COLOR",
  BACKGROUND_IMAGE: "BACKGROUND_IMAGE",
  CNAME: "CNAME",
  CID: "CID",
  DARK_MODE: "DARK_MODE",
  IS_PUBLIC_FUNKO: "IS_PUBLIC_FUNKO",
  IS_PUBLIC_LOUNGEFLY: "IS_PUBLIC_LOUNGEFLY",
  IS_PUBLIC_MONDO: "IS_PUBLIC_MONDO",
  PRODUCTS: "PRODUCTS",
  TITLE: "TITLE",
  PRODUCT_LICENSE: "PRODUCT_LICENSE",
  PRODUCT_NAME: "PRODUCT_NAME",
  PRODUCT_PRICE: "PRODUCT_PRICE",
  PRODUCT_EYEBROW: "PRODUCT_EYEBROW",
  PRODUCT_FOOTER: "PRODUCT_FOOTER",
  PRODUCT_NUMBER: "PRODUCT_NUMBER",
  PRODUCT_INDEX: "PRODUCT_INDEX",
  PRODUCT_IMAGE: "PRODUCT_IMAGE",
  PRODUCT_SKU: "PRODUCT_SKU",
  PRODUCT_IS_SOLD_OUT: "PRODUCT_IS_SOLD_OUT",
  ADD_PRODUCT_SKU: "ADD_PRODUCT_SKU",
});
